import { Button } from "@mui/material";
import { toDate } from "helpers/dateHelper";
import { CONNECTION_STATUS } from "pages/Admin/Whatsapp/WhatsappConnect";
import { useTranslation } from "react-i18next";
import { FaInstagram } from "react-icons/fa";
import { toast } from "react-toastify";
import AgentsService from "services/admin/AgentsService";

const INSTAGRAM_CLIENT_ID = "1833186257567007";
const INSTAGRAM_REDIRECT_URI =
  "https://admin.hajjtravel.kz/admin/ai-agents/instagram/oauth/callback";
/**
 * Scopes for Instagram Business API
 * instagram_business_basic - Basic access to Instagram Business API
 * instagram_business_manage_messages - Manage messages in Instagram Business API
 */
const scopes = ["instagram_business_basic", "instagram_business_manage_messages", "instagram_business_manage_comments"];
const INSTAGRAM_SCOPE = scopes.join("%2C");
const RESPONSE_TYPE = "code";

interface InstagramConnectProps {
  channelConnection: any;
  refetch: () => void;
}

export const InstagramConnect = ({ channelConnection, refetch }: InstagramConnectProps) => {
  const { t } = useTranslation();

  const INSTAGRAM_STATE = JSON.stringify({
    agentID: channelConnection.agentID,
    channelConnectionID: channelConnection.id,
    orgID: channelConnection.orgID,
  });
  const INSTAGRAM_STATE_ENCODED = encodeURIComponent(INSTAGRAM_STATE);

  const handleDisconnect = async () => {
    console.log("Отсоединение от Instagram");
    try {
      const { data } = await AgentsService.disconnectInstagram(channelConnection.id);
      toast.success("Instagram отсоединен успешно!");
      console.log("data: ", data);
      refetch();
    } catch (error) {
      console.error(error);
      toast.error("Ошибка при отсоединении от Instagram");
    }
  };

  const buildContent = () => {
    if (channelConnection.connectionStatus === CONNECTION_STATUS.CONNECTED) {
      return (
        <section>
          <div>
            <div>Instagram Account ID: {channelConnection.externalAccountID}</div>
            <div>Instagram Username: {channelConnection.externalAccountUserName}</div>
            <div>Instagram First Name: {channelConnection.externalAccountFirstName}</div>
            {/* <div>Токен истекает: {toDate(channelConnection.expiredAt)}</div> */}
          </div>
          <div className="mt-4">
            <Button variant="outlined" color="error" onClick={handleDisconnect}>
              Отсоединить Instagram
            </Button>
          </div>
        </section>
      );
    }
    return (
      <a
        href={`https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=${INSTAGRAM_CLIENT_ID}&redirect_uri=${INSTAGRAM_REDIRECT_URI}&response_type=${RESPONSE_TYPE}&scope=${INSTAGRAM_SCOPE}&state=${INSTAGRAM_STATE_ENCODED}`}
      >
        {/* Background color of instagram logo */}
        {/* #c13584 */}
        <Button
          variant="contained"
          style={{
            background: "linear-gradient(45deg, #405de6, #5851db, #833ab4, #c13584, #e1306c, #fd1d1d)",
          }}
        >
          <FaInstagram size={20} className="mr-2" />
          {t("Подключить Instagram")}
        </Button>
      </a>
    );
  };

  return <div className="mt-4">{buildContent()}</div>;
};
